<div class="doc-tile" [class.has-subtitle]="!!file()?.description">
  <div class="doc-main">
    <i [class]="iconClass()"></i>
    <span class="doc-name">{{ file()?.name ?? "—" }}</span>
  </div>

  <button
    type="button"
    class="doc-download"
    (click)="onDownload()"
    [attr.aria-label]="'Download ' + (file()?.name ?? 'file')"
    title="Download"
  >
    <i class="fas fa-arrow-down"></i>
  </button>

  @if (file()?.description; as description) {
  <div class="doc-subtitle">{{ description }}</div>
  }
</div>
